import { render, staticRenderFns } from "./bulk-actions.vue?vue&type=template&id=0e9e312c&"
import script from "./bulk-actions.vue?vue&type=script&lang=js&"
export * from "./bulk-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports